import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserProfile, UserProfileAdapter } from '../Models/user-profile';
import { ApiRestService } from './api-rest.service';
//import { ApiService } from './api.service';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

// type ProfileType = {
//   givenName?: string,
//   surname?: string,
//   userPrincipalName?: string,
//   id?: string
// };

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  userProfile: UserProfile;

  // private userProfilState$ = new BehaviorSubject<UserProfile>({
  // });
  // currentUserProfile$ = this.userProfilState$.asObservable();

  constructor(private apiRestService : ApiRestService
            , private userProfileAdapter : UserProfileAdapter) { }

  getProfile() : UserProfile {
    this.userProfile = this.getUserProfileStorage();
    if (this.userProfile === undefined || this.userProfile === null || Object.keys(this.userProfile).length === 0) {
      this.getProfile_Adapter().subscribe(
        data => {
          this.userProfile = data;
          this.setUserProfileStorage(this.userProfile);
        }
      );
    }
    return this.userProfile;
    //return this.apiService.getJsonRestApi(GRAPH_ENDPOINT, 'Azure AD');
  }

  uploadFile() {

  }
  
  private getProfile_Adapter() : Observable<UserProfile> {
    return this.apiRestService.getJasonRestApi(GRAPH_ENDPOINT, 'Azure AD').pipe(
      map(
        ( data :any ) => this.userProfileAdapter.adapt(data))
    );
  }

  private setUserProfileStorage(userProfile: UserProfile) {
    localStorage.setItem('UserADProfile', JSON.stringify(userProfile));
    //this.userProfilState$.next(userProfile);
  }

  private getUserProfileStorage() {
    let userProfileStorage = localStorage.getItem('UserADProfile');

    if (userProfileStorage === "" || userProfileStorage === null) {
      UserProfile : this.userProfile = {};
    }
    else {
      this.userProfile = JSON.parse(userProfileStorage);
    }
    return this.userProfile;
  }
}
